<body class="route-admin-ido">
  <!-- Table header -->
  <app-table-header
    [headerText]="CONSTANTS.WELCOME_TEXT"
    [filterDisabled]="!isFilterEnabled"
    [rightPadding]="5"
    [hasCollapsedPadding]="false"
    (clearFilterEvent)="clearAllFilters()"
    (exportExcelEvent)="exportExcel()"
    (addItemEvent)="addRoute()"
  ></app-table-header>
  <div class="route-admin-ido-table-container">
    <table mat-table [dataSource]="dataSource" class="route-admin-ido-table">
      <caption>
        Route Admin
      </caption>
      <!-- Route ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.ROUTE">
        <th mat-header-cell *matHeaderCellDef id="route-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.ROUTE"
            [control]="routeData.formControl"
            [maxLength]="3"
            [columnWidth]="130"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="route-headers"
          class="left-data-column"
        >
          {{ admin.route_id }}
        </td>
      </ng-container>

      <!-- LBT ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.LBT">
        <th mat-header-cell *matHeaderCellDef id="lbtID-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LBT"
            [control]="lbtData.formControl"
            [maxLength]="5"
            [columnWidth]="130"
            [inputType]="INPUT_TYPE.time"
            [allowedSpecialChars]="CHARS.TIME"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="lbtID-headers"
          class="left-data-column"
        >
          {{ admin.leavebldg_time }}
        </td>
      </ng-container>

      <!-- Optimize ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.OPTIMIZE">
        <th mat-header-cell *matHeaderCellDef id="optimizeID-headers">
          <app-table-dropdown-status
            [header]="COLUMNTEXT.OPTIMIZE"
            [data]="optimizeData"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[0]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
            "
            (emitStatusChange)="onStatusChange($event, optimizeData)"
          >
          </app-table-dropdown-status>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="optimizeID-headers"
          class="center-data-column"
        >
          @switch (admin.is_optimizeroute) {
            @case (true) {
              <img
                class="color-active"
                [src]="IMAGES.ACTIVE"
                [alt]="ImageOptions.ACTIVE"
              />
            }
            @case (false) {
              <img
                class="color-inactive"
                [src]="IMAGES.CANCEL"
                [alt]="ImageOptions.DEACTIVATED"
              />
            }
          }
        </td>
      </ng-container>

      <!-- Location Start ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.LOCATION">
        <th mat-header-cell *matHeaderCellDef id="locationStart-headers">
          <ion-row class="th-text location-address-headers">
            {{ COLUMNTEXT.LOCATION }}
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="locationStart-headers"
          class="left-data-column"
        >
          {{ admin.startend_location }}
        </td>
      </ng-container>

      <!-- Address Start ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.ADDRESS">
        <th mat-header-cell *matHeaderCellDef id="addressID-headers">
          <ion-row class="th-text location-address-headers">
            {{ COLUMNTEXT.ADDRESS }}
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="addressID-headers"
          class="left-data-column"
        >
          {{ admin.startend_address }}
        </td>
      </ng-container>

      <!-- Break ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.BREAK">
        <th mat-header-cell *matHeaderCellDef id="breakID-headers">
          <ion-row class="th-text no-padding">
            {{ COLUMNTEXT.BREAK }}
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="breakID-headers"
          class="center-data-column"
        >
          @if (admin.break_exist === true) {
            <img
              class="color-active"
              [src]="IMAGES.ACTIVE"
              alt="ImageOptions.ACTIVE"
            />
          }
          @if (admin.break_exist === false) {
            <img
              class="color-inactive"
              [src]="IMAGES.CANCEL"
              alt="ImageOptions.DEACTIVATED"
            />
          }
        </td>
      </ng-container>

      <!-- Break Time ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.BREAK_TIME">
        <th mat-header-cell *matHeaderCellDef id="breakTimeID-headers">
          <ion-row class="th-text align-right">
            {{ COLUMNTEXT.BREAK_TIME }}
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="breakTimeID-headers"
          class="right-data-column"
        >
          @if (admin.break_exist) {
            {{ admin.break_start }} -
            {{ admin.break_end }}
          }
        </td>
      </ng-container>

      <!-- Duration ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.DURATION">
        <th mat-header-cell *matHeaderCellDef id="durationID-headers">
          <ion-row class="th-text align-right">
            {{ COLUMNTEXT.DURATION }}
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="durationID-headers"
          class="right-data-column"
        >
          @if (admin.break_exist) {
            {{ admin.break_duration }}
          }
        </td>
      </ng-container>

      <!-- Del Wait Time ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.DEL_WAIT_TIME">
        <th mat-header-cell *matHeaderCellDef id="delWaitTimeID-headers">
          <ion-row class="th-text align-right">
            {{ COLUMNTEXT.DEL_WAIT_TIME }}
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="delWaitTimeID-headers"
          class="right-data-column"
        >
          {{ admin.waittime_del }}
        </td>
      </ng-container>

      <!-- PU Wait Time ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.PU_WAIT_TIME">
        <th mat-header-cell *matHeaderCellDef id="puWaitTimeID-headers">
          <ion-row class="th-text align-right">
            {{ COLUMNTEXT.PU_WAIT_TIME }}
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="puWaitTimeID-headers"
          class="right-data-column"
        >
          {{ admin.waittime_pickup }}
        </td>
      </ng-container>

      <!-- Vehicle ID -->
      <ng-container [matColumnDef]="COLUMN_IDS.VEHICLE">
        <th mat-header-cell *matHeaderCellDef id="vehicleID-headers">
          <ion-row class="th-text">
            {{ COLUMNTEXT.VEHICLE }}
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="vehicleID-headers"
          class="left-data-column"
        >
          {{ admin.vehicle }}
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container [matColumnDef]="COLUMN_IDS.ACTION">
        <th mat-header-cell *matHeaderCellDef id="action-headers">
          <ion-row class="th-text center">
            {{ COLUMNTEXT.ACTIONS }}
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td
          mat-cell
          *matCellDef="let admin; let i = index"
          headers="action-headers"
        >
          <app-table-action-cell
            [data]="admin"
            [deleteButtonDisabled]="false"
            (emitEditButton)="editRoute(admin)"
            (emitDeleteButton)="removeRoute(admin)"
          ></app-table-action-cell>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="IDS; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: IDS; let i = index"></tr>

      <tr class="mat-row no-results" *matNoDataRow>
        <td class="mat-cell no-border" [attr.colspan]="IDS.length">
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
